import React from "react";
import { team } from "../data";

const Team = () => {
  return (
    <section id="team" className="section bg-[#f8f3ec] py-20 relative">
      <div className="container mx-auto text-center px-6">
        {/* Title with Icon - matches About section */}
        <div className="flex items-center justify-center gap-3 mb-12">
          <h2 className="text-3xl font-extrabold text-primary tracking-wide text-center">
            Founder & Managing Attorney | Cire Legal
          </h2>
        </div>

        {/* Attorney Profile */}
        <div className="flex justify-center">
          {team.map((item, index) => {
            const { image, name, position, description } = item;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md p-8 hover:shadow-lg transition duration-300 max-w-[720px]"
              >
                <img
                  src={image}
                  alt={name}
                  className="mx-auto mb-6 rounded-full object-cover w-full max-w-[380px] h-auto"
                />
                <h4 className="text-2xl mb-2 font-primary font-bold text-primary">
                  {name}
                </h4>
                <p className="text-sm uppercase tracking-[0.3px] mb-4 text-accent font-semibold">
                  {position}
                </p>
                <p className="max-w-[540px] mx-auto text-gray-700">
                  {description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Team;
